import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { getEncounterStatus } from 'ziphy-web-shared/basic/entities/encounters';
import { Duration } from 'ziphy-web-shared/basic/lib/functional';
import styles from './EncounterDuration.module.scss';
const EncounterDuration = ({ encounter, className }) => {
    const { t } = useTranslation();
    const { isCancelled, isInProgress, isFinished } = getEncounterStatus(encounter);
    const isVisible = isCancelled || isInProgress || isFinished;
    if (!isVisible) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: [isCancelled && (_jsxs(_Fragment, { children: [t('label.canceled'), encounter.startTime && (_jsxs(_Fragment, { children: ["\u00A0", _jsx(Duration, { from: encounter.startTime || encounter.cancelTime, to: encounter.cancelTime, ignoreRightZero: false })] }))] })), isInProgress && (_jsxs(_Fragment, { children: [t('label.in_progress'), "\u00A0", _jsx(Duration, { from: encounter.startTime, ignoreRightZero: false })] })), isFinished && (_jsxs(_Fragment, { children: [t('label.completed'), "\u00A0", _jsx(Duration, { from: encounter.startTime, to: encounter.finishTime, ignoreRightZero: false })] }))] })));
};
export default memo(EncounterDuration);
